import { render, staticRenderFns } from "./sales-return-settle-add-or-update.vue?vue&type=template&id=8e924598&scoped=true"
import script from "./sales-return-settle-add-or-update.vue?vue&type=script&lang=js"
export * from "./sales-return-settle-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./sales-return-settle-add-or-update.vue?vue&type=style&index=0&id=8e924598&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e924598",
  null
  
)

export default component.exports